<div class="p-2 fill-column">
  <div class="font-semibold text-2xl mb-3" data-clarity-unmask="true">Baza pytań</div>
  <app-question-list class="w-full fill-column"></app-question-list>
</div>
